import React, { createContext, useContext } from "react";
const ClientContext = createContext(null);
export function ClientProvider({ client, children, }) {
    return (React.createElement(ClientContext.Provider, { value: client }, children));
}
export default function useClient() {
    const client = useContext(ClientContext);
    if (!client) {
        throw Error("useClient: `client` is undefined. Seems you forgot to wrap your form in `<ClientProvider />`");
    }
    return client;
}
//# sourceMappingURL=useClient.js.map